module.exports = __webpack_public_path__ + "img/logo_white.6470aaa6.png";